'use client'

import { signout } from '@onclicks/sharedmedusa/medusaData/customer'
import { UserCircleIcon as UserCircleIconSolid } from '@heroicons/react/24/solid'
import { UserCircleIcon as UserCircleIconOutline } from '@heroicons/react/24/outline'
import { HttpTypes } from '@medusajs/types'
import Link from 'next/link'
import React, { useEffect, useRef, useState } from 'react'

export const UserMenu = ({
  customer,
  iconSize = 28,
}: {
  customer: HttpTypes.StoreCustomer | null
  iconSize?: number
}) => {
  return (
    <Link href="/account" aria-label="Se connecter" className="flex items-center">
      {customer ? (
        <UserCircleIconSolid width={iconSize} height={iconSize} className=" mt-0.5 icon-gradient" />
      ) : (
        <UserCircleIconOutline
          width={iconSize}
          height={iconSize}
          className=" mt-0.5 text-primary"
        />
      )}
    </Link>
  )
}
